import { Route } from 'src/store';
import { ReportingContainer } from './container';
import { ReportingBatchContainer } from './batch/container';
import { CreateScheduledReportContainer, EditScheduledReportContainer } from './scheduler/container';
import { ReportingParametersContainer } from './parameters/container';

export const reportingRoutes: Route[] = [
  {
    path: '/reporting',
    component: ReportingContainer,
    exact: true,
  },
  {
    path: '/reporting/:id',
    component: ReportingBatchContainer,
  },
  {
    path: '/scheduler/create',
    component: CreateScheduledReportContainer,
  },
  {
    path: '/scheduler/edit/:id',
    component: EditScheduledReportContainer,
  },
  {
    path: '/parameters/edit/:id',
    component: ReportingParametersContainer,
  },
  {
    path: '/parameters/create',
    component: ReportingParametersContainer,
  },
];
